import { render, staticRenderFns } from "./Request.vue?vue&type=template&id=716275ab"
import script from "./Request.vue?vue&type=script&setup=true&lang=js"
export * from "./Request.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports